export const interndata = [
  {
    type:"Internship",
    img: "https://internfreak.co/uploads/ProPeers.png",
    date: "8/11/2023",
    title: "Hiring React Native Developer Intern at ProPeers",
    companydesc: "Join ProPeers, a dynamic and forward-thinking team that's revolutionizing the way people connect with mentors. Our platform simplifies the process of finding the right mentors to help answer your queries, allowing you to focus on your personal and professional growth.", 
    designation: "React Native Developer Intern",
    batch: "2023, 2024, 2025, 2026",
    stipend: "20k per month",
    location: "Remote",
    qualifications: ["Collaborate with the product manager and the design team to validate and implement new features through experimentation.",
    " Monitor application performance and proactively address bugs to optimize the user experience.",
    "Refactor and rewrite obsolete code, ensuring alignment with our updated architecture.",
    "Design, develop, and maintain a high-performance, reusable, and reliable code base using React Native.",
    "Stay abreast of emerging technologies, evaluate their potential impact, and implement relevant solutions to enhance development efficiency."],
    link: "https://docs.google.com/forms/d/e/1FAIpQLSfveaydnRmQ3DSIFSW-KGVtMBoGAuxsxbbHfhZypPpP0GaQaA/viewform"
  },
  {
    type:"Internship",
    img: "https://internfreak.co/uploads/sharechat.png",
    date: "7/18/2023",
    title: "ML Intern - Generative AI Freshers Job Opening At ShareChat",
    companydesc: "ShareChat (https://sharechat.com/about) is India’s largest social media and content marketplace platform that operates exclusively in Indic languages. We empower over 300 million strong monthly active users to share their opinions, record their lives and make new friends - all within the comfort of their language of choice. We are the leaders in the social content space in India with Moj being India’s largest short- video platform (160+ million MAUs, 50 million creators), and Sharechat being India’s leading social media and content marketplace platform that operates exclusively in 15 Indic languages (180 million MAUs, 32+ million creators).", 
    designation: "ML Intern",
    batch: "2023, 2024",
    location: "Remote",
    qualifications: ["Familiarity with LLMs/Diffusion models",
    "Comfortable in working on machine learning frameworks like Tensorflow, PyTorch and libraries like scikit-learn",
    "Outstanding analytical and problem-solving skillsExcellent coding skills in at least one of Python, Go, C/C++, Java, NodeJS. Knowledge of SQL is a huge plus",
    "Understanding of data structures, data modeling and software architecture",
    "Some knowledge of agile development methodologies (Git/Github, Docker, Jupyter Notebook)"],
    link: "https://sharechat.mynexthire.com/employer/jobs?p=eyJwYWdlVHlwZSI6ImpkIiwiY3ZTb3VyY2UiOiJjYXJlZXJzIiwicmVxSWQiOjE2MjAsInJlcXVlc3RlciI6eyJpZCI6IiIsImNvZGUiOiIiLCJuYW1lIjoiIn0sInBhZ2UiOiJjYXJlZXJzIiwiYnVmaWx0ZXIiOi0xfQ%3D%3D" 
  },
  {
    type:"Internship",
    img: "https://internfreak.co/uploads/Stack.png",
    date: "7/17/2023",
    title: "Stack(YC S21) is hiring for Software Engineer Intern (Vuejs)",
    companydesc: "Stack is a Y Combinator backed startup, on a mission to make private wealth experience accessible to the emerging affluent of India. Stack is backed by world-class investors including funds like Y Combinator, Harvard Management, Goodwater Capital, and eminent individuals including Kunal Shah (Cred), Tanuj Shori (Squareyards).",
    designation: "Software Engineer Intern",
    batch: "2022, 2023, 2024",
    stipend: "30-50k per month",
    location: "Remote",
    why: ["Opportunity to work with a dynamic and innovative team in the fast-growing wealth management industry.",
    " Gain hands-on experience in developing web applications using Vue.js.",
    "Exposure to cutting-edge technologies and the chance to contribute to the growth of a promising startup.",
    "Competitive compensation package and potential for growth within the company.",
    "Collaborative and supportive work environment that values creativity and personal development."],
    link: "https://docs.google.com/forms/d/e/1FAIpQLSeQyNleULw9V80eKShE3q2P_a9z_YVIrMSOZg01TCzuuuQSBQ/viewform"
  },
  {
    type:"Job",
    img: "https://internfreak.co/uploads/Hushh.ai.PNG",
    date: "7/17/2023",
    title: "iOS Developer position open at hushh.ai",
    companydesc: "With hushh, you can monetize your data while prioritizing your privacy preferences if you choose to, allowing your trusted brands to serve you via the best virtual and human assistants. Our mission is to help make “your” data “your” business. We do this by helping you extract meaningful insights & solutions from your most valuable personal data that helps you and your family understand the power that lies within your personal data once you start collecting, organizing and managing it as a personal asset on your own devices.",
    designation: "iOS Developer",
    batch: "2021, 2022, 2023",
    salary: "INR 4.5 Lakhs to INR 11.9 Lakhs per year",
    location: "Remote / Chennai",
    role: "You will be the maestro conducting our symphony of code, leading the creation of our iOS applications. Your masterpiece will be the 'HushhMag,' a social news feed as unique as our users themselves, and a digital wallet that's as secure as a personal vault.",
    qualifications: ["A degree in Computer Science, Software Engineering, or a related field, or an equivalent self-taught maestro of code.",
    
    "Five or more years composing beautiful, functional applications for iOS, demonstrating your proficiency in Swift, Objective-C, and essential iOS SDKs."],
    link: "https://www.linkedin.com/jobs/view/3661024297/"
  },
  {
      type:"Internship",
      img: "https://internfreak.co/uploads/Doeasily.png",
      date: "7/16/2023",
      title: "Software Engineer Intern Position Open At Doeasily",
      companydesc: "Doeasily is an early stage startup focussed on building something really cool for Indian SMBs. Our mission is to make it easier to do business with integration of new age tech into traditional Indian businesses. We're looking for someone passionate about building an app from a user first approach. We're currently bootstrapped and looking for individuals who are extremely passionate about building SaaS products.",
      designation: "Software Engineer Intern",
      batch: "2023, 2024, 2025",
      stipend: "10k-40k per month",
      location: "Remote",
      skills: "React Native",
      qualifications: ["Currently pursuing a Bachelor's or Master's degree in Computer Science, Software Engineering, or a related field.",

      "Solid understanding of frontend development principles and experience with React Native.",
      
      "Knowledge of responsive design principles and experience developing mobile-friendly user interfaces.",
      
      "Familiarity with RESTful APIs and asynchronous programming concepts."],
      link: "https://www.linkedin.com/jobs/view/3662366563",
    },
    {
      type:"Internship",
      img: "https://internfreak.co/uploads/AdmitKard.png",
      date: "7/15/2023",
      title: "Fullstack Developer Internship At AdmitKard - Noida",
      companydesc: "AdmitKard, is a Noida-based Ed-Tech platform that helps students who are looking to take admission in Universities and Colleges Abroad in countries such as US, UK, Australia, Canada, NZ, Singapore. We help student in the entire journey from Test Prep, Profile Building, Admissions, Education Loan to Student Visa. Our aim is to not only help students get into college but also get out of college successfully.",
      designation: "Full-Stack Developer Intern",
      batch: "2023, 2024, 2025",
      stipend: "₹ 23K - 25K",
      location: "Noida, Uttar Pradesh, India",
      duration: "5 months",
      qualifications: ["Strong logical ability in solving real life problems.",
      
      "Understanding and knowledge of distributed databases and architecture.",
      
      "Passionate and driven about scalable and extendable micro services."],
      link: "https://cuvette.tech/app/public/internship/64af9419d0c6a5e6fbf53163?referralCode=ODXKEU",
    },
    {
      type:"Internship",
      img: "https://internfreak.co/uploads/Google.png",
      date: "7/14/2023",
      title: "Software Engineering Intern, Summer 2024 At Google",
      companydesc: "Google LLC is an American multinational technology company that specializes in Internet-related services and products, which include a search engine, online advertising technologies, cloud computing, software, and hardware. Google’s parent company Alphabet Inc. is considered one of the Big Five American information technology companies, alongside Amazon, Apple, Meta and Microsoft.",
      designation: "Software Engineer Intern",
      batch: "2025, 2026",
      stipend: "1 Lakh / Month",
      location: "Multiple Locations",
      skills: "React Native",
      qualifications: ["Currently pursuing a Bachelor's, Master's or PhD degree in Computer Science or related technical field.",
      
      "Experience in software development in one or more general purpose programming languages.",
      
      "Ability to speak and write in English fluently.",],
      link: "https://www.google.com/about/careers/applications/jobs/results/131573075612181190-software-engineering-intern-summer-2024",
    },
    {
      type:"Internship",
      img: "https://internfreak.co/uploads/Amdocs.jpeg",
      date: "7/14/2023",
      title: "Amdocs Is hiring for Remote SDE Interns",
      companydesc: "Amdocs is a leading software & services provider to the world's most successful communications and media companies.",
      designation: "SDE Intern",
      batch: "2022, 2023, 2024, 2025",
      lastdate: "1 Lakh / Month",
      location: "Remote",
      duration: "6-9 Months",
      qualifications: ["Collaborate to create engaging web apps with React and Node.js.",
      
      "Write clean, efficient, and well-documented code that follows industry standards.",
      
      "Conduct thorough testing and debugging of applications to ensure high-quality deliverables.",
    
      "Keep up-to-date with the latest web development technologies and techniques and a knack for learning.",
    
      "Supporting tech issues and maintaining the system."],

      link: "https://www.linkedin.com/posts/pranjali-patil-266b41257_hiringalert-hiringpost-hiring-activity-7085002413555773441-YXap?utm_source=share&utm_medium=member_android",
    },




    {
      type:"Internship",
      img: "https://internfreak.co/uploads/Doeasily.png",
      date: "7/16/2023",
      title: "Software Engineer Intern Position Open At Doeasily",
      companydesc: "Doeasily is an early stage startup focussed on building something really cool for Indian SMBs. Our mission is to make it easier to do business with integration of new age tech into traditional Indian businesses. We're looking for someone passionate about building an app from a user first approach. We're currently bootstrapped and looking for individuals who are extremely passionate about building SaaS products.",
      designation: "Software Engineer Intern",
      batch: "2023, 2024, 2025",
      stipend: "10k-40k per month",
      location: "Remote",
      skills: "React Native",
      qualifications: ["Currently pursuing a Bachelor's or Master's degree in Computer Science, Software Engineering, or a related field.",

      "Solid understanding of frontend development principles and experience with React Native.",
      
      "Knowledge of responsive design principles and experience developing mobile-friendly user interfaces.",
      
      "Familiarity with RESTful APIs and asynchronous programming concepts."],
      link: "https://www.linkedin.com/jobs/view/3662366563",
    },
    {
      type:"Internship",
      img: "https://internfreak.co/uploads/Doeasily.png",
      date: "7/16/2023",
      title: "Software Engineer Intern Position Open At Doeasily",
      companydesc: "Doeasily is an early stage startup focussed on building something really cool for Indian SMBs. Our mission is to make it easier to do business with integration of new age tech into traditional Indian businesses. We're looking for someone passionate about building an app from a user first approach. We're currently bootstrapped and looking for individuals who are extremely passionate about building SaaS products.",
      designation: "Software Engineer Intern",
      batch: "2023, 2024, 2025",
      stipend: "10k-40k per month",
      location: "Remote",
      skills: "React Native",
      qualifications: ["Currently pursuing a Bachelor's or Master's degree in Computer Science, Software Engineering, or a related field.",

      "Solid understanding of frontend development principles and experience with React Native.",
      
      "Knowledge of responsive design principles and experience developing mobile-friendly user interfaces.",
      
      "Familiarity with RESTful APIs and asynchronous programming concepts."],
      link: "https://www.linkedin.com/jobs/view/3662366563",
    },
    {
      type:"Internship",
      img: "https://internfreak.co/uploads/Doeasily.png",
      date: "7/16/2023",
      title: "Software Engineer Intern Position Open At Doeasily",
      companydesc: "Doeasily is an early stage startup focussed on building something really cool for Indian SMBs. Our mission is to make it easier to do business with integration of new age tech into traditional Indian businesses. We're looking for someone passionate about building an app from a user first approach. We're currently bootstrapped and looking for individuals who are extremely passionate about building SaaS products.",
      designation: "Software Engineer Intern",
      batch: "2023, 2024, 2025",
      stipend: "10k-40k per month",
      location: "Remote",
      skills: "React Native",
      qualifications: ["Currently pursuing a Bachelor's or Master's degree in Computer Science, Software Engineering, or a related field.",

      "Solid understanding of frontend development principles and experience with React Native.",
      
      "Knowledge of responsive design principles and experience developing mobile-friendly user interfaces.",
      
      "Familiarity with RESTful APIs and asynchronous programming concepts."],
      link: "https://www.linkedin.com/jobs/view/3662366563",
    },
    {
      type:"Internship",
      img: "https://internfreak.co/uploads/Doeasily.png",
      date: "7/16/2023",
      title: "Software Engineer Intern Position Open At Doeasily",
      companydesc: "Doeasily is an early stage startup focussed on building something really cool for Indian SMBs. Our mission is to make it easier to do business with integration of new age tech into traditional Indian businesses. We're looking for someone passionate about building an app from a user first approach. We're currently bootstrapped and looking for individuals who are extremely passionate about building SaaS products.",
      designation: "Software Engineer Intern",
      batch: "2023, 2024, 2025",
      stipend: "10k-40k per month",
      location: "Remote",
      skills: "React Native",
      qualifications: ["Currently pursuing a Bachelor's or Master's degree in Computer Science, Software Engineering, or a related field.",

      "Solid understanding of frontend development principles and experience with React Native.",
      
      "Knowledge of responsive design principles and experience developing mobile-friendly user interfaces.",
      
      "Familiarity with RESTful APIs and asynchronous programming concepts."],
      link: "https://www.linkedin.com/jobs/view/3662366563",
    },
  ];